<template>
    <div
        class="form-group"
        v-bind="groupBinder"
    >
        <div class="input-wrapper">
            <label class="form-label" :for="inputId">{{ inputLabel }}<span v-if="required" class="required">*</span></label>
            <input
                class="form-control"
                type="color"
                :value="color || undefined"
                v-bind="inputBinder"
                v-on="inputListener"
            >
        </div>
    </div>
</template>

<script>
import { mixin } from './mixins/inputFunctions';
export default {
    mixins: [mixin],
    computed: {
        color() {
            return this.value && this.value.toUpperCase().match(/\#[0-9A-F]{6}/g) ? this.value : "#000000";
        }
    }
}
</script>

<style lang="scss" scoped>
    .input-wrapper { position: relative; }

    .form-control::-webkit-calendar-picker-indicator { cursor: pointer; }

    .form-label {
        margin: 0;
        font-size: 14px;
        font-weight: bold;

        .input-wrapper & {
            position: absolute;
            font-size: 12px;
            top: 0;
            left: .25rem;
            opacity: 1;
            background-color: white;
            transform: translateY(-50%);
            padding: 0 .25rem;
            line-height: 1;
            border-radius: 2px;
        }
    }
</style>